<div class="registration-form-card set-password-card">
  <!-- Loading State -->
  @if (loading) {
    <div class="loading-container">
      <div class="loading-spinner"></div>
      <p>Loading...</p>
    </div>
  }

  <!-- Invalid Link State -->
  @if (!loading && !linkValid) {
    <div class="error-state">
      <div class="error-icon">
        <div class="error-circle">
          <span class="error-exclamation">!</span>
        </div>
      </div>
      <h1 class="form-title">Invalid Link</h1>
      <div class="error-message">
        <p>The link URL is not valid. Please check that you clicked the correct link from your email.</p>
      </div>
      <div class="action-buttons">
        <button type="button" class="btn btn-primary" (click)="$window.location.href = '/login'">
          Go to Login
        </button>
      </div>
    </div>
  }

  <!-- Set Password Form -->
  @if (!loading && linkValid) {
    <div class="password-form">
      <h1 class="form-title">Set Your Password</h1>
      <p class="form-subtitle">
        Your uTest account has been verified. Create your password and login to your account.
      </p>
      <form (ngSubmit)="onSubmit()" #passwordForm="ngForm">
        <!-- Name Field (Read-only display) -->
        <div class="form-group">
          <label class="form-label">Name</label>
          <div class="read-only-field">{{ name }}</div>
        </div>
        <!-- Email Field (Read-only display) -->
        <div class="form-group">
          <label class="form-label">Email</label>
          <div class="read-only-field">{{ email }}</div>
        </div>
        <!-- Password Field with Toggle -->
        <div class="form-group">
          <label for="password" class="form-label">
            Password <span class="required">*</span>
          </label>
          <div class="password-input-wrapper">
            <input [type]="passwordVisible ? 'text' : 'password'" id="password" name="password" class="form-input"
              [(ngModel)]="password" required autocomplete="new-password" aria-label="Password, requirements are detailed below."  />
            <button type="button" class="password-toggle"  (click)="togglePasswordVisibility()">
              <i class="visibility-icon material-icons" id="password-visibility-toggle" [attr.aria-label] = "passwordVisible ? 'Toggle show password, Visible' : 'Toggle show password, Hidden'">
                {{ passwordVisible ? 'visibility_off' : 'visibility' }}
              </i>
            </button>
          </div>
        </div>
        <!-- Spaces notice -->
        @if (hasLeadingOrTrailingSpaces()) {
          <div class="spaces-notice" role="alert">
            <span>Your password cannot contain leading or trailing spaces. Please remove them to continue.</span>
          </div>
        }
        <!-- Password Requirements Checklist -->
        <div class="password-requirements-list">
          <ul aria-label="Password criteria:">
            <li class="requirement-item" >
              <span class="requirement-icon {{hasMinLength()? 'password-check': 'password-circle'}}"></span>
              {{ lengthRequirement }}
              <span class="sr-only">{{ hasMinLength() ? requirementMet : requirementNotMet }}</span>
            </li>
            <li class="requirement-item" >
              <span class="requirement-icon {{hasUppercase()? 'password-check': 'password-circle'}}"></span>
              {{ uppercaseRequirement }}
              <span class="sr-only">{{ hasUppercase() ? requirementMet : requirementNotMet }}</span>
            </li>
            <li class="requirement-item">
              <span class="requirement-icon {{hasLowercase()? 'password-check': 'password-circle'}}"></span>
              {{ lowercaseRequirement }}
              <span class="sr-only">{{ hasLowercase() ? requirementMet : requirementNotMet }}</span>
            </li>
            <li class="requirement-item">
              <span class="requirement-icon {{hasNumber()? 'password-check': 'password-circle'}}"></span>
              {{ numberRequirement }}
              <span class="sr-only">{{ hasNumber() ? requirementMet : requirementNotMet }}</span>
            </li>
            <li class="requirement-item">
              <span class="requirement-icon {{doesNotContainEmail()? 'password-check': 'password-circle'}}"></span>
              {{ emailRequirement }}
              <span class="sr-only">{{ doesNotContainEmail() ? requirementMet : requirementNotMet }}</span>
            </li>
          </ul>
        </div>
        <!-- Error Message -->
        @if (error) {
          <div class="error-alert">
            <p class="error-text">{{ error }}</p>
          </div>
        }
        <!-- Submit Button and Helper Text -->
        <div class="submit-with-info">
          <button type="submit" class="btn-create-account" [disabled]="!isPasswordValid() || submissionInProgress">
            @if (!submissionInProgress) {
              <span>Set Password</span>
            }
            @if (submissionInProgress) {
              <span>Setting Password...</span>
            }
          </button>
          <p class="redirect-info">
            Once password is set, you will be redirected to <a href="/login" class="login-link">login</a>.
          </p>
        </div>
      </form>
    </div>
  }

  <!-- Help Section -->
  <div class="help-section">
    <p class="help-text">
      Having issues or need help? Contact us at
      <a href="https://support.utest.com/csp?id=csp_login_help_page" class="help-link" target="_blank"
      rel="noopener noreferrer">support.utest.com</a>
    </p>
  </div>
</div>
